import React, { useState, useEffect } from "react";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import { Panel, PanelBody } from "../../components/panel/panel.jsx";
import "../../assets/css/custom.css";
import { useHistory } from "react-router-dom";
import {
	UncontrolledButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import {
	ApiUrl,
	ApiKey,
	WebUrl,
	AccessRight,
	LanguageKey,
} from "../../util/Constant";
import NavigationButton from "../../components/constantComponent/button/NavigationButton";
import { checkIfPermissionExist } from "../../util/PermissionChecker";
import { useTranslation } from "react-i18next";
import { fetch } from "whatwg-fetch";

/// <summary>
/// Author : -
/// </summary>

const ManageDCPoints = (props) => {
	const { t } = useTranslation(LanguageKey._PRIMARY);
	let _history = useHistory();
	const [dailyCheckInData, setDailyCheckInData] = useState([]);

	let _tableColumns = [
		{
			Header: t("TITLE"),
			accessor: "title",
			disableSortBy: true,
		},
		{
			Header: t("STATUS"),
			accessor: "status",
			Cell: ({ row }) => (
				<div className="btn-group m-r-5 m-b-5">
					{row.original.status == true ? (
						<span className="badge badge-secondary badge-green">
							{t("ACTIVE")}
						</span>
					) : (
						<span className="badge badge-secondary badge-danger">
							{t("SUSPENDED")}
						</span>
					)}
				</div>
			),
			disableSortBy: true,
			style: { overflow: "visible" },
		},
		{
			id: "action",
			Header: t(""),
			Cell: ({ row }) =>
				checkIfPermissionExist(
					AccessRight._DAILY_CHECK_IN_PERMISSION,
					true
				) && (
					<div className="btn-group m-r-5 m-b-5">
						<UncontrolledButtonDropdown>
							<DropdownToggle caret color="default">
								<i className="fas fa-cog"></i>
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem
									onClick={() => {
										_history.push({
											pathname: WebUrl._URL_DAILY_CHECK_IN_DETAIL,
											state: {
												refId: row.original.id,
											},
										});
									}}
								>
									<span className="text-warning">{t("EDIT")}</span>
								</DropdownItem>
								<DropdownItem
									onClick={() => {
										_history.push({
											pathname: WebUrl._URL_DAILY_CHECK_IN_DETAIL,
											state: {
												cloneId: row.original.id,
											},
										});
									}}
								>
									<span className="text-primary">{t("CLONE")}</span>
								</DropdownItem>
							</DropdownMenu>
						</UncontrolledButtonDropdown>
					</div>
				),
			disableSortBy: true,
			disableFilters: true,
			width: 100,
			style: { overflow: "visible" },
		},
	];

	/// <summary>
	/// Author : -
	/// </summary>
	useEffect(() => {
		fetch(ApiUrl._API_GET_DAILY_CHECK_IN + "?all=true", {
			method: ApiKey._API_GET,
			headers: {
				"Content-Type": ApiKey._API_FORM_URLENCODED,
				"X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
			},
		})
			.then((response) => response.json())
			.then((responseJson) => {
				if (responseJson[ApiKey._API_SUCCESS_KEY]) {
					var data = responseJson[ApiKey._API_DATA_KEY];

					var monthOrder = {
						January: 1,
						February: 2,
						March: 3,
						April: 4,
						May: 5,
						June: 6,
						July: 7,
						August: 8,
						September: 9,
						October: 10,
						November: 11,
						December: 12,
					};

					data.sort(function (a, b) {
						var monthA = monthOrder[a.title];
						var monthB = monthOrder[b.title];
						return monthA - monthB;
					});

					setDailyCheckInData(data);
				}
			});
	}, []);

	return (
		<div>
			<h1 className="page-header">
				{t("CHECK_IN_POINT_SETTINGS")}
				{checkIfPermissionExist(
					AccessRight._DAILY_CHECK_IN_PERMISSION,
					true
				) && (
					<NavigationButton
						history={_history}
						url={WebUrl._URL_DAILY_CHECK_IN_DETAIL}
						buttonText={t("ADD_DAILY_CHECK_IN")}
					/>
				)}
			</h1>
			<Panel>
				<PanelBody>
					<ReactTable data={dailyCheckInData} columns={_tableColumns} />
				</PanelBody>
			</Panel>
		</div>
	);
};

export default ManageDCPoints;
